import http from 'utils/http';
import { MonthlyRevenue, RevenueAnalytics, RevenueBreakdown } from './types';
import { MetaApiResponse } from '@/utils/types/CommonApiResponse';
import {
  getAgencyMontlyRevenueUrl,
  getAgencyRevenueAnalyticsUrl,
  getAgencyRevenueBreakdownUrl,
  getFetchAgencyBusinessInvoiceUrl
} from './apiUrls';

export function getAgencyRevenueAnalytics(params?: Record<string, any>): Promise<RevenueAnalytics> {
  return http.get(getAgencyRevenueAnalyticsUrl(), params);
}

export function getAgencyRevenueBreakdown(
  params?: Record<string, any>
): Promise<{ data: RevenueBreakdown[]; meta: MetaApiResponse }> {
  return http.get(getAgencyRevenueBreakdownUrl(), params);
}

export function getAgencyMontlyRevenue(
  id: number,
  params?: Record<string, any>
): Promise<{ id: number; data: MonthlyRevenue[]; meta: MetaApiResponse }> {
  return http.get(getAgencyMontlyRevenueUrl(id), params);
}

export function fetchAgencyBusinessInvoice(businessId: number, id: number): Promise<{ url: string }> {
  return http.get(getFetchAgencyBusinessInvoiceUrl(businessId, id));
}
